import { useEffect, useRef, useState } from 'react';
import DashboardSidebar from './Sections/DashboardSidebar';
import DashboardTopbar from './Sections/DashboardTopbar.jsx';
// import SetupPage from './DashboardPages/Setup';
import { useSearchParams } from 'react-router-dom';
// import Setup from './Setup/Setup'
import { useNavigate } from 'react-router-dom';
import { v4 as uuid } from 'uuid';
import allTabs, { tabs, sales_channels, bottom_tabs } from './DashboardTabs';
import DashboardSubTabs from '../components/ui/DashboardSubTabs';
import { useDispatch } from 'react-redux';
import systemSlice from '../redux/systemSlice';

const LayeredDashboard = ({ tab, isActive }) => {

    const navigate = useNavigate()
    const dispatch = useDispatch()


    return (
        <>
            <div className={`fixed top-[100dvh] w-full h-full duration-500 ${isActive ? "animate-fade-in" : "animate-fade-out"} bg-[#F8F8F8]`} >

                {(tab.grid) ?
                    <DashboardSubTabs activeTab={tab} subTabs={tab.subTabs}></DashboardSubTabs> :
                    tab?.component ? <tab.component tab={tab}></tab.component> : <></>
                }


            </div>
        </>

    );
};

export default LayeredDashboard;
